import { useVideo } from "@100mslive/react-sdk";
import React, { useEffect, useRef, useState } from "react";

const sizes = {
  sm: { size: "w-10 h-10", fontSize: "text-lg" },
  md: { size: "w-20 h-20", fontSize: "text-xl" },
  lg: { size: "w-32 h-32", fontSize: "text-2xl" },
  xl: { size: "w-48 h-48", fontSize: "text-3xl" },
  "2xl": { size: "w-64 h-64", fontSize: "text-4xl" }
};

const UserIcon = ({
  variant = "default",
  isVideoEnabled,
  trackId,
  size = "md",
  name = "",
  peer
}) => {
  const { videoRef } = useVideo({
    trackId,
    mirror: true,
    attach: true
  });
  const localVideoRef = useRef(null);
  const [hasCameraPermission, setHasCameraPermission] = useState(true);

  useEffect(() => {
    if (peer?.demoUser) {
      // Get local device video stream
      navigator.mediaDevices
        .getUserMedia({ video: true })
        .then((stream) => {
          if (localVideoRef.current) {
            localVideoRef.current.srcObject = stream;
            setHasCameraPermission(true);
          }
        })
        .catch((err) => {
          console.error("Error accessing camera:", err);
          setHasCameraPermission(false);
        });

      return () => {
        // Cleanup stream when component unmounts
        if (localVideoRef.current?.srcObject) {
          localVideoRef.current.srcObject.getTracks().forEach((track) => track.stop());
        }
      };
    }
  }, [peer?.demoUser]);

  const initials = name?.includes(" ")
    ? name
        .split(" ")
        .map((word) => word[0])
        .join("")
        .toUpperCase()
        .split("")
        .reduce((acc, letter, i, arr) => (i === 0 || i === arr.length - 1 ? acc + letter : acc), "")
    : name?.slice(0, 2).toUpperCase() || "";

  if (peer?.demoUser) {
    if (hasCameraPermission) {
      return (
        <div className={`${sizes[size].size} relative overflow-hidden`}>
          <video
            ref={localVideoRef}
            autoPlay
            playsInline
            muted
            className={`w-full h-full rounded-full object-cover ${
              variant === "default"
                ? "border-4 border-orange-100"
                : variant === "moderator"
                  ? "border-4 border-green-500"
                  : ""
            }`}
          />
        </div>
      );
    }
    // Show initials if camera permission is denied
    return (
      <div className={`${sizes[size].size} relative overflow-hidden`}>
        <div
          className={`w-full h-full rounded-full flex items-center justify-center ${
            variant === "default"
              ? "border-2 border-orange-500 bg-orange-200"
              : variant === "moderator"
                ? "border-2 border-green-500 bg-green-50"
                : ""
          }`}>
          <span className={`${sizes[size].fontSize} font-medium`}>{initials}</span>
        </div>
      </div>
    );
  }

  return (
    <div className={`${sizes[size].size} relative overflow-hidden`}>
      {isVideoEnabled && trackId ? (
        <video
          id={trackId}
          key={trackId}
          ref={videoRef}
          autoPlay
          playsInline
          muted
          className={`w-full h-full rounded-full object-cover ${
            variant === "default"
              ? "border-4 border-orange-100"
              : variant === "moderator"
                ? "border-4 border-green-500"
                : ""
          }`}
        />
      ) : (
        <div
          className={`w-full h-full rounded-full flex items-center justify-center ${
            variant === "default"
              ? "border-2 border-orange-500 bg-orange-200"
              : variant === "moderator"
                ? "border-2 border-green-500 bg-green-50"
                : ""
          }`}>
          <span className={`${sizes[size].fontSize} font-medium`}>{initials}</span>
        </div>
      )}
    </div>
  );
};

export default UserIcon;
